export default __webpack_public_path__ + "static/kafka-commands-b56a540a47aa3934763c133aa6b0f095.png";